/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Box } from "@material-ui/core";
import React from "react";
import { useSelector } from "store";

import { StreamingActionHeader } from "./StreamingActionHeader";
import { StreamingAnnouncement } from "./StreamingAnnouncement";
import StreamingLiveCommerceV2 from "./StreamingLiveCommerceV2";
import { StreamingLiveEventV2 } from "./StreamingLiveEventV2";

import type { CommentFilterType } from "modules/streaming";
import type { FC } from "react";
import type { EventInfo } from "utility";

type Props = {
  eventInfo: EventInfo;
  currentVideoId: string;
  THEOPlayerElementHeight: number;
  isOpenAnnouncement: boolean;
  isEditingAnnouncement: boolean;
  selectedCommentFilter: CommentFilterType;
  streamingAnnouncement: string;
  handleToggleAnnouncement: () => void;
  setIsEditingAnnouncement: (isEditing: boolean) => void;
  setStreamingAnnouncement: (announcement: string) => void;
  handleChangeCommentFilter: (filter: CommentFilterType) => void;
  handleCloseActionArea: () => void;
  isLiveEventEnabled: boolean;
  isOpenLiveEvent: boolean;
  handleToggleLiveEvent: () => void;
};

/**
 * UserActionArea
 * comment, gift, (later: goods sales, quiz, vote)
 * @param props
 */
const StreamingActionAreaV2Goods: React.FC<Props> = (props) => {
  // ----- Redux State -----
  const isDarkModeEnabled = useSelector(
    (state) => state.streaming.streamingSettings.isDarkModeEnabled
  );

  const isAdmin = useSelector((state) => state.admin.isAdmin);
  const streamingType = useSelector((state) => state.streaming.streamingType);

  return (
    <React.Fragment>
      <StreamingActionAreaLayout
        header={
          <StreamingActionHeader
            isDarkModeEnabled={isDarkModeEnabled}
            handleChangeCommentFilter={props.handleChangeCommentFilter}
            handleToggleAnnouncement={props.handleToggleAnnouncement}
            handleCloseActionArea={props.handleCloseActionArea}
            selectedCommentFilter={props.selectedCommentFilter}
            showAnnouncement={isAdmin || props.streamingAnnouncement !== ""}
            isLiveEventEnabled={props.isLiveEventEnabled}
            handleToggleLiveEvent={props.handleToggleLiveEvent}
          />
        }
      >
        {props.isOpenLiveEvent && <StreamingLiveEventV2 />}

        <StreamingAnnouncement
          eventId={props.eventInfo.eventId}
          currentVideoId={props.currentVideoId}
          streamingType={streamingType}
          isOpenAnnouncement={props.isOpenAnnouncement}
          isEditingAnnouncement={props.isEditingAnnouncement}
          streamingAnnouncement={props.streamingAnnouncement}
          setIsEditingAnnouncement={props.setIsEditingAnnouncement}
          setStreamingAnnouncement={props.setStreamingAnnouncement}
        />

        <StreamingLiveCommerceV2
          currentVideoId={props.currentVideoId}
          THEOPlayerElementHeight={props.THEOPlayerElementHeight}
        />
      </StreamingActionAreaLayout>
    </React.Fragment>
  );
};
export default StreamingActionAreaV2Goods;

const StreamingActionAreaLayout: FC<{
  children: React.ReactNode;
  header: React.ReactNode;
}> = ({ children, header }) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gridGap={"12px"}
      padding={"12px"}
    >
      {header}
      {children}
    </Box>
  );
};
